import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import * as HTTPServices from "../../../api/HTTPServices";
import { useTranslation } from "react-i18next";
import classes from "./index.module.scss";

let counter = 0;
function createData(key, name, date, time, price) {
  counter += 1;
  return { id: counter, key, name, date, time, price };
}

function Index() {
  const { t } = useTranslation();
  const [tableDate, setTableDate] = useState([]);

  useEffect(() => {
    const RequestService = HTTPServices.getMethod(
      "user_transaction",
      "",
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        let data = [];
        response.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.price
            )
          );
          return data;
        });

        setTableDate(data);
      }
    }).catch(function (error) {});
  }, []);
  return (
    <div className={classes.mainContainer}>
      <h3 className={classes.title}>
        {t("pages.protectedPages.patientTransactions.title")}
      </h3>
      <hr></hr>
      <p>{t("pages.protectedPages.patientTransactions.p1")}</p>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <DataTable rows={tableDate} columns={columns} />
      </div>
    </div>
  );
}

export default Index;

const columns = [
  {
    id: 1,
    field: "name",
    headerName: "Name of doctor or consultant",
    width: 250,
  },
  { id: 2, field: "date", headerName: "date", width: 180 },
  { id: 3, field: "time", headerName: "time", width: 180 },
  { id: 4, field: "price", headerName: "price", width: 180 },
];
